import axios from "axios";

export const state = {
    alevelstaffloads: [],
};

export const getters = {
    alevelstaffloads: state => state.alevelstaffloads,
};

export const mutations = {
    setAstaff(state, newValue) {
        state.alevelstaffloads = newValue
    },
};

export const actions = {
    fetchAlevelStaffloads({ commit }) {
        axios.get('/alevelstaffloads').then(res => {
            commit('setAstaff', res.data.alevelstaffloads);
        })
    },
};
